// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"\"../common/styles/breakpoints.css\"","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 992px)","block":"b2u79","title":"_3G13C"};